import { render, staticRenderFns } from "./WizardComponent.vue?vue&type=template&id=433ba542&scoped=true&"
import script from "./WizardComponent.vue?vue&type=script&lang=js&"
export * from "./WizardComponent.vue?vue&type=script&lang=js&"
import style0 from "./WizardComponent.vue?vue&type=style&index=0&id=433ba542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ba542",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VForm,VRow,VSkeletonLoader})
